import { render } from "./SubmenuTopUser.vue?vue&type=template&id=78c6c784&scoped=true"
import script from "./SubmenuTopUser.vue?vue&type=script&lang=js"
export * from "./SubmenuTopUser.vue?vue&type=script&lang=js"

import "./SubmenuTopUser.vue?vue&type=style&index=0&id=78c6c784&scoped=true&lang=css"
import "./SubmenuTopUser.vue?vue&type=style&index=1&id=78c6c784&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c6c784"]])

export default __exports__